<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama", "AltDonemId", "KAltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },

      ilkDonemVerileri: [],
      ikinciDonemVerileri: [],
      TabloVerileri: [],

      donem_yili: "",
      BirimAdi: "",
      ilkyil: "",
      sonyil: "",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId() {
      this.Get();
    },
  },

  methods: {
    Get() {
      this.bugun = new Date();

      let bos_tablo = {
        Riskid: "",
        Tespitedilenrisk: "",
        Stratejikhedef: "",
        Birimhedefi: "",
        Toplampuan: "",
        Puanlayansayisi: "",
        Donemriskpuanim: "",
        Kontrolyontemleri: "",
        Cevaplar: "",
      };

      this.ActionsGet({
        Service: "StrPerfDonem/" + this.AltDonemId,
        Page: this.Page,
      }).then((res) => {
        this.ilkyil = res.Data.YilBas;
      });

      this.ActionsGet({
        Service: "StrPerfDonem/" + this.KAltDonemId,
        Page: this.Page,
      }).then((res) => {
        this.sonyil = res.Data.YilBit;
      });

      let Filter =
        "&Donemid=" + this.DonemId + "&AltDonemid=" + this.AltDonemId;
      if (this.BirimId != null && this.BirimId != "") {
        Filter = Filter + "&Birimid=" + this.BirimId;
      }

      this.ActionsFilterGet({
        Service: "StrRaporlama/GetRiskKarsilastirmaRaporu",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        if (res) {
          this.ilkDonemVerileri = res.Data;

          let Filter2 =
            "&Donemid=" + this.DonemId + "&AltDonemid=" + this.KAltDonemId;
          if (this.BirimId != null && this.BirimId != "") {
            Filter2 = Filter2 + "&Birimid=" + this.BirimId;
          }

          this.ActionsFilterGet({
            Service: "StrRaporlama/GetRiskKarsilastirmaRaporu",
            Page: this.Page,
            Filter: Filter2,
          }).then((res2) => {
            if (res2) {
              this.ikinciDonemVerileri = res2.Data;
              this.TabloVerileri = [];

              for (var i = 0; i < this.ilkDonemVerileri.length; i++) {
                let kontrol = 0;

                for (var s = 0; s < this.ikinciDonemVerileri.length; s++) {
                  if (
                    this.ilkDonemVerileri[i].Riskid ==
                    this.ikinciDonemVerileri[s].Riskid
                  ) {
                    kontrol = 1;

                    this.TabloVerileri.push({
                      donem1: this.ilkDonemVerileri[i],
                      donem2: this.ikinciDonemVerileri[s],
                    });

                    this.ikinciDonemVerileri.splice(s, 1);
                  }
                }
                if (kontrol == 0) {
                  // ilk dönemde olup ikinci dönemde olmayan risk verileri için

                  this.TabloVerileri.push({
                    donem1: this.ilkDonemVerileri[i],
                    donem2: bos_tablo,
                  });
                }
              }

              if (this.ikinciDonemVerileri.length > 0) {
                //ikinci dönemde olup birincide olmayan

                for (var k = 0; k < this.ikinciDonemVerileri.length; k++) {
                  this.TabloVerileri.push({
                    donem1: bos_tablo,
                    donem2: this.ikinciDonemVerileri[k],
                  });
                }
              }
              this.TabloVerileri.sort(this.buyuktenKucugeSiralama);
            }
          });
        }
      });

      if (this.BirimId != null && this.BirimId != "") {
        this.BirimGetir(this.BirimId);
      }
    },
    buyuktenKucugeSiralama(a, b) {
      return b.donem1.Donemriskpuanim - a.donem1.Donemriskpuanim;
    },
    cevap_duzenle(cevaplar) {
      let liste = cevaplar.split(",");

      let cevap_listesi = "";

      for (var i = 1; i < liste.length; i++) {
        let sira = i.toString() + " - ";
        if (i > 1) {
          cevap_listesi = cevap_listesi + " <br> " + sira + liste[i];
        } else {
          cevap_listesi = cevap_listesi + sira + liste[i];
        }
      }

      return cevap_listesi;
    },

    yontem_duzenle(yontemler) {
      let liste = yontemler.split(",");
      let yontem_listesi = "";

      for (var i = 0; i < liste.length; i++) {
        let yontem = "";

        if (liste[i] == 1) {
          yontem = "Yeni Kontrol";
        }
        if (liste[i] == 2) {
          yontem = "Ek Kontrol";
        }
        if (liste[i] == 3) {
          yontem = "Kaldırılan Kontrol";
        }
        if (liste[i] == 4) {
          yontem = "Yönlendirici Kontroller";
        }
        if (liste[i] == 5) {
          yontem = "Önleyici Kontroller";
        }
        if (liste[i] == 6) {
          yontem = "Tespit Edici Kontroller";
        }
        if (liste[i] == 7) {
          yontem = "Düzeltici Kontrol";
        }

        if (i > 1) {
          yontem_listesi = yontem_listesi + " <br> " + yontem;
        } else {
          yontem_listesi = yontem_listesi + yontem;
        }
      }

      return yontem_listesi;
    },

    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.riskkarsilastirma;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },
Bol(Data) {
  if (Data) {
    let metinDizisi = Data.split("|").map(item => item.trim()); 

    metinDizisi.sort((a, b) => {
      const numA = parseInt(a.match(/^\d+/)?.[0] || 0, 10);
      const numB = parseInt(b.match(/^\d+/)?.[0] || 0, 10);

      if (numA !== numB) return numA - numB;

      const textA = a.replace(/^\d+-\s*/, "").toLowerCase();
      const textB = b.replace(/^\d+-\s*/, "").toLowerCase();

      return textA.localeCompare(textB, "tr", { sensitivity: "base" });
    });

    return metinDizisi; // Dizi olarak döndür
  }
  return [];
}


,
    BirimGetir(birimid) {
      this.ActionsGet({ Service: "OBirim/" + birimid, Page: this.Page }).then(
        (res) => {
          this.BirimAdi = res.Data.BirimAdi;
        }
      );
    },
  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
    <div class="text-sm-end">
      <button
        type="button"
        class="btn btn-success btn-rounded mb-2 me-2"
        @click="ExcelExport('Risk Raporu', 'Risk Raporu')"
      >
        <i class="mdi mdi-file-export-outline me-1"></i>
        Excel'e Aktar
      </button>
    </div>

    <div ref="riskkarsilastirma" class="table-responsive">
      <div class="table-responsive">
        <table style="width:100%">
          <tr>
            <td colspan="12" style="text-align: center;">
              <div><h4>KURUMSAL/ OPERASYONEL RİSK RAPORU</h4></div>
            </td>
          </tr>
          <tr>
            <td colspan="12" style="text-align: right;">{{ sonyil }}</td>
          </tr>
        </table>

        <br />

        <table
          style="border: 1px solid; border-collapse: collapse; "
          border="1"
          class="table  table-md table-bordered border-success mb-0"
        >
          <thead class="table-light">
            <tr>
              <th>Kurum / Birim Adı</th>
              <th colspan="14" style="font-size:16px ; vertical-align:center;">
                <span>{{ BirimAdi }}</span>
              </th>
            </tr>
            <tr>
              <th rowspan="2">Sıra No</th>
              <th>Tespit Edilen Risk</th>
              <th>Riskin Etkileyeceği Hedefler</th>
              <th>&nbsp;</th>
              <th rowspan="2">{{ ilkyil }} Risk Puanı</th>
              <th rowspan="2">Mevcut Kontrol Yöntemi</th>
              <th rowspan="2">Riske Verilen Cevaplar</th>
              <th rowspan="2">Yapılacak Eylemler</th>
              <th rowspan="2">Tamalanan Eylemler</th>
              <th rowspan="2">{{ sonyil }} Risk Puanı</th>
              <th rowspan="2">Yeni/Ek/Kaldırılan Kontrol Yöntemi</th>
              <th rowspan="2">Riske Verilecek Cevaplar</th>
              <th rowspan="2">Yapılacak Eylemler</th>
              <th rowspan="2">Açıklama</th>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <th>Stratejik Hedef</th>
              <th>Birim/Alt Birim Hedefi</th>
            </tr>
          </thead>
          <tbody v-for="(Risk, index) in TabloVerileri" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ Risk.donem1.Tespitedilenrisk }}</td>
              <td>{{ Risk.donem1.Stratejikhedef }}</td>
              <td>{{ Risk.donem1.Birimhedefi }}</td>
              <td class="text-center" :style="{ background: Risk.donem1.Renk }">
                <span style="color: black">{{
                  Math.round(Risk.donem1.Donemriskpuanim)
                }}</span>
              </td>
              <td>
                <span v-if="Risk.donem1.Mevcutkontrol == 2"
                  >Yönlendirici Kontrol</span
                ><span v-if="Risk.donem1.Mevcutkontrol == 3"
                  >Önleyici Kontrol</span
                ><span v-if="Risk.donem1.Mevcutkontrol == 4"
                  >Düzeltici Kontrol</span
                ><span v-if="Risk.donem1.Mevcutkontrol == 5"
                  >Tespit Edici Kontrol</span
                >
              </td>
              <td>{{ Risk.donem1.Cevaplar }}</td>
              <td>
                <ul
                  v-for="(Data2, index) in Bol(Risk.donem1.Kontrolyontemleri)"
                  :key="index"
                >
                  <li>{{ Data2 }}</li>
                </ul>
              </td>
              <td>
                <ul
                  v-for="(Data2, index) in Bol(
                    Risk.donem1.tamamlanankontrolyontemleri
                  )"
                  :key="index"
                >
                  <li>{{ Data2 }}</li>
                </ul>
              </td>
              <td class="text-center" :style="{ background: Risk.donem2.Renk }">
                <span style="color: black">{{
                  Math.round(Risk.donem2.Donemriskpuanim)
                }}</span>
              </td>
              <td>
                <span v-if="Risk.donem2.Mevcutkontrol == 2"
                  >Yönlendirici Kontrol</span
                ><span v-if="Risk.donem2.Mevcutkontrol == 3"
                  >Önleyici Kontrol</span
                ><span v-if="Risk.donem2.Mevcutkontrol == 4"
                  >Düzeltici Kontrol</span
                ><span v-if="Risk.donem2.Mevcutkontrol == 5"
                  >Tespit Edici Kontrol</span
                >
              </td>
              <td>{{ Risk.donem2.Cevaplar }}</td>
              <td>
                <ul
                  v-for="(Data2, index) in Bol(Risk.donem2.Kontrolyontemleri)"
                  :key="index"
                >
                  <li>{{ Data2 }}</li>
                </ul>
              </td>
              <td>{{ Risk.donem1.Aciklama }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
